import * as THREE from 'three';

interface ZoomableNode {
  geometry?: THREE.BufferGeometry | null;
  boundingBox?: THREE.Box3;
  [key: string]: unknown;
}

declare module 'three' {
  interface OrthographicCamera {
    zoomTo(node: ZoomableNode, factor?: number): void;
  }
}

THREE.OrthographicCamera.prototype.zoomTo = function (node: ZoomableNode, factor = 1) {
  if (!node.geometry && !node.boundingBox) {
    return;
  }

  // TODO

  //let minWS = new THREE.Vector4(node.boundingBox.min.x, node.boundingBox.min.y, node.boundingBox.min.z, 1);
  //let minVS = minWS.applyMatrix4(this.matrixWorldInverse);

  //let right = node.boundingBox.max.x;
  //let bottom	= node.boundingBox.min.y;
  //let top = node.boundingBox.max.y;

  this.updateProjectionMatrix();
};
